module.exports = __webpack_public_path__ + "static/media/x350d.9cfe7b56.jpg";